import { SuperPayVerificationStatus } from 'shared/settings/CarrierSettingsAPI';
import {
  SUPERPAY_PROFILE_ROUTES,
  SUPERPAY_WEBVIEW_ROUTES,
} from './SuperPayRoute';

export function getSuperPayProfilePathsByStatus(
  status?: SuperPayVerificationStatus | null,
) {
  switch (status) {
    case 'restricted':
      return [SUPERPAY_PROFILE_ROUTES.promo];
    case 'bank_account':
      return [SUPERPAY_PROFILE_ROUTES.bankDetails];
    case 'bank_account_verification':
    case 'verified':
    case 'bank_account_failed':
    case 'bank_account_errored':
      return [SUPERPAY_PROFILE_ROUTES.accountDetails];
    default:
      return [
        SUPERPAY_PROFILE_ROUTES.promo,
        SUPERPAY_PROFILE_ROUTES.businessDetails,
      ];
  }
}

export function getSuperPayWebViewPathsByStatus(
  status?: SuperPayVerificationStatus | null,
) {
  switch (status) {
    case 'restricted':
      return [SUPERPAY_WEBVIEW_ROUTES.promo];
    case 'bank_account':
      return [
        SUPERPAY_WEBVIEW_ROUTES.bankDetails,
        SUPERPAY_WEBVIEW_ROUTES.changeBankAccount,
      ];
    case 'bank_account_verification':
    case 'verified':
    case 'bank_account_failed':
    case 'bank_account_errored':
      return [
        SUPERPAY_WEBVIEW_ROUTES.accountDetails,
        SUPERPAY_WEBVIEW_ROUTES.bankVerification,
        SUPERPAY_WEBVIEW_ROUTES.changeBankAccount,
        SUPERPAY_WEBVIEW_ROUTES.requestShipper,
      ];
    default:
      return [
        SUPERPAY_WEBVIEW_ROUTES.promo,
        SUPERPAY_WEBVIEW_ROUTES.businessDetails,
      ];
  }
}
